// @owners { team: patients }
import { Card, Description, SmSpacing } from '@alto/design-system';
import { Experimentation } from '@alto/experimentation';
import React from 'react';
import { ADDRESS_MESSAGES } from '~shared/features/checkout/constants';
import { getOrderDate } from '~shared/features/checkout/selectors/getOrder';
import { getOrderIndex } from '~shared/features/checkout/selectors/getOrdersByIndex';
import { useSelectorShared } from '~shared/store';
import { useSignatureConfirmation } from '../../hooks/useSignatureConfirmation';
import { AddressInfoAlert } from '../delivery-address-card/address-info/AddressInfoAlert';
import { HomeToSignConfirmation } from '../delivery-address-card/address-info/HomeToSignConfirmation';

export const SignatureConfirmationCard = () => {
  const { value: isPickupToggleEnabled } = Experimentation.useFeatureFlag('scheduling_module_pickup_toggle');
  const orderIndex = useSelectorShared(getOrderIndex);
  const orderDate = useSelectorShared(getOrderDate);
  const { homeToSignConfirmationRequired, signatureRequired, expensive } = useSignatureConfirmation();

  if (!homeToSignConfirmationRequired || (!isPickupToggleEnabled && !orderDate)) return null;

  return (
    <Card title={signatureRequired ? 'Signature required' : 'Delivery instructions'}>
      {expensive && (
        <>
          <AddressInfoAlert type="warning">
            <Description>{ADDRESS_MESSAGES.expensive}</Description>
          </AddressInfoAlert>
          <SmSpacing />
        </>
      )}
      <HomeToSignConfirmation
        isSignatureRequired={signatureRequired}
        orderIndex={orderIndex}
      />
    </Card>
  );
};
